import { Link, useParams } from 'react-router-dom';
import programas from './data/programas';
import './FormacionTecnica.css';

const ProgramaTecnicoLaboral = () => {
  const { slug } = useParams();
  const programa = programas.find((item) => item.slug === slug);

  if (!programa) {
    return (
      <main className="programa-detalle programa-no-encontrado">
        <h1>No encontramos ese programa</h1>
        <Link to="/formaciontecnicolaboral">Volver a Técnico Laboral</Link>
      </main>
    );
  }

  return (
    <main className="programa-detalle">
      <div className="programa-detalle-breadcrumb">
        <Link to="/formaciontecnicolaboral">Técnico Laboral</Link>
        <span aria-hidden="true">/</span>
        <span>{programa.nombreCorto}</span>
      </div>

      <section className="programa-detalle-contenido">
        <div className="programa-detalle-copy">
          <p className="programa-detalle-eyebrow">Programa Técnico Laboral</p>
          <h1>{programa.titulo}</h1>
          <p className="programa-detalle-texto">
            Fórmate en el programa de {programa.nombreCorto.toLowerCase()} del Instituto de Educación de la Cruz Roja Colombiana Seccional Sucre.
          </p>
          <div className="programa-detalle-descuento" aria-label="Descuentos anunciados en la pieza promocional">
            <strong>15% / 20%</strong>
            <span>de descuento anunciado</span>
          </div>
          <a
            className="programa-detalle-cta"
            href={`https://wa.me/573127431631?text=${encodeURIComponent(`Hola, quiero información sobre el programa Técnico Laboral en ${programa.titulo}.`)}`}
            target="_blank"
            rel="noreferrer"
          >
            Solicitar información
          </a>
          <p className="programa-detalle-contacto">312 743 1631 · Calle 38 No. 29-18, Carretera Troncal</p>
        </div>
        <img
          className="programa-detalle-afiche"
          src={programa.imagen}
          alt={`Afiche del programa Técnico Laboral en ${programa.titulo}`}
          loading="lazy"
          decoding="async"
        />
      </section>

      <section className="programa-detalle-informacion" aria-label={`Información del programa ${programa.titulo}`}>
        <div className="programa-detalle-informacion-grid">
          {programa.informacion.map((bloque) => (
            <article className="programa-info-card" key={bloque.titulo}>
              <div className="programa-info-card-titulo">
                <span className="programa-info-icono" aria-hidden="true">{bloque.icono}</span>
                <h3>{bloque.titulo}</h3>
              </div>
              {bloque.texto ? (
                <p>{bloque.texto}</p>
              ) : (
                <ul>
                  {bloque.elementos.map((elemento) => <li key={elemento}>{elemento}</li>)}
                </ul>
              )}
            </article>
          ))}
        </div>
      </section>

      {programa.conoceMas && (
        <section className="programa-conoce-mas" aria-labelledby="programa-conoce-mas-titulo">
          <div className="programa-conoce-mas-marca" aria-hidden="true">+</div>
          <div>
            <h2 id="programa-conoce-mas-titulo">Conoce más:</h2>
            <p className="programa-conoce-mas-texto">{programa.conoceMas}</p>
          </div>
        </section>
      )}

      <Link className="programa-volver" to="/formaciontecnicolaboral#programas">← Ver todos los programas</Link>
    </main>
  );
};

export default ProgramaTecnicoLaboral;
